import React, { Component } from 'react';
import { NormalButton } from "../Components/Buttons"
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import { ReviewCard } from "../Components/Cards"
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
class ViewReview extends Component {
    constructor(props) {
        super(props);


        this.state = {
            isVisible: false,
            length: "",
            data: []
        }
    }

    fadeIn() {
        setTimeout( () => {
            this.setState({isVisible : true});
        }, 0)        
    }

    getAllReviews() {
        axios.get('/getAllReviews')
            .then(response => response.data)
            .then(data => {
                this.setState({
                    length: data.length,
                    data: data
                });
            });

    }

    getAllReviewsSortRating() {
        axios.get('/getAllReviewsSortRating')
            .then(response => response.data)
            .then(data => {
                console.log(data)
                this.setState({
                    length: data.length,
                    data: data
                });
                // console.log(this.state.data)
            });        
    }

    componentDidMount() {
        this.getAllReviews();
        // this.fadeIn();
    }
    render () {
        return (
            <div className="ViewReview">
                <div className="Home">
                    <div >
                        <h1 className="Home-Title">The Cafe Log</h1>
                    </div>

                    <div>
                        <p className="Home-Para">A compilation of every cafe visited, with expert analysis on each.</p>
                    </div>
                    
                </div>
                {/* <div className="Home-Options">
                    <Container>
                        <Row>
                            <Col>                        
                                <NormalButton link="/addreview" text="Add new Review"></NormalButton>
                            </Col>
                            <Col>
                                <NormalButton link="/" text="Back to Home"></NormalButton>
                            </Col>
                        </Row>
                    </Container>
                </div> */}
                <div className="Home-Options">
                    <ButtonGroup>
                        <NormalButton link="/addreview" text="Add new Review"></NormalButton>
                        <NormalButton link="/" text="Back to Home"></NormalButton>
                    </ButtonGroup>
                </div>
                <div className="Home-Under">

                        <p className="Home-Para2-Review">View all reviews below!</p>
                        <Container>
                            <Row>
                                <Col>
                                    <Button
                                        style= {{backgroundColor: '#FFBF9B ', borderColor: "#4D4D4D", color: '#000000'}}
                                        block 
                                        onClick={(event) => {this.getAllReviews();}}
                                        >Sort by Date
                                    </Button>
                                </Col>
                                <Col>
                                    <Button
                                        style= {{backgroundColor: '#FFF4E0 ', borderColor: "#4D4D4D", color: '#000000'}}
                                        block 
                                        onClick={(event) => {this.getAllReviewsSortRating();}}
                                        >Sort by Rating
                                    </Button>   
                                </Col>
                            </Row>
                        </Container><br></br>              
                </div>
                <br></br>
                <div className="ViewReview-Form-Outer">
                    {this.state.data.map( curData => (
                        <ReviewCard Title={curData.Name} Location={curData.Location} 
                        Date={curData.Date} p1coffee={curData.P1CoffeeRating}
                        p1food={curData.P1FoodRating}
                        p1location={curData.P1LocationRating}
                        p1staff={curData.P1StaffRating}
                        p1comments={curData.P1Comments}
                        p2coffee={curData.P2CoffeeRating}
                        p2food={curData.P2FoodRating}
                        p2location={curData.P2LocationRating}
                        p2staff={curData.P2StaffRating}
                        p2comments={curData.P2Comments}
                        AvgRating={curData.OverallRatingCalc}></ReviewCard>
                        
                    ))}
                </div>
            </div>
        );
    };
};

export default ViewReview;